
import React from 'react'
import TaskCard from '../TaskCard'
import EmptyState from '../EmptyState'

interface DiscoverTask {
  id: string
  title: string
  description: string | null
  module: string | null
  domain: string | null
  priority: boolean
  source: 'admin' | 'school'
}

interface DiscoverTasksListProps {
  tasks: DiscoverTask[]
  onAddTask: (taskId: string, taskSource: 'admin' | 'school') => void
}

const DiscoverTasksList: React.FC<DiscoverTasksListProps> = ({ tasks, onAddTask }) => {
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Discover Tasks</h2>
      <div className="space-y-3">
        {tasks.map(task => (
          <TaskCard 
            key={task.id} 
            task={{
              id: task.id,
              title: task.title,
              module: task.module || undefined,
              description: task.description || undefined,
              badge: task.domain || (task.source === 'admin' ? 'Global' : 'University'),
              priority: task.priority
            }}
            showBadge={true}
            showActions={true}
            actionType="add"
            onAction={(taskId) => onAddTask(taskId, task.source)}
          />
        ))}

        {tasks.length === 0 && (
          <EmptyState title="Discover Tasks" message="No discover tasks available" />
        )}
      </div>
    </div>
  )
}

export default DiscoverTasksList
